<div style="width: 500px; height: 500px; margin: 100px auto; border: 1px solid red">
  <snapmatic-progress [status]="status" [position]="position"></snapmatic-progress>
</div>

<div style="width: 500px; height: 500px; margin: 100px auto">
<div class="flex flex-col">
  <select [(ngModel)]="status" class="text-black">
    <option value="awaiting">awaiting</option>
    <option value="running_detection">running_detection</option>
    <option value="generation">generation</option>
    <option value="generation_0_5">generation_0_5</option>
    <option value="generation_1_5">generation_1_5</option>
    <option value="generation_2_5">generation_2_5</option>
    <option value="generation_3_5">generation_3_5</option>
    <option value="generation_4_5">generation_4_5</option>
    <option value="uploading">uploading</option>
    <option value="complete">complete</option>
    <option value="error">error</option>
  </select>
</div>
</div>
